const SubjectList = () => import('Views/subject/subject-list');
const SubjectDetail = () => import('Views/subject/subject-detail');

export default[
  { path: '/subject-list', component: SubjectList },
  { path: '/subject-detail/:id', component: SubjectDetail },
];



// WEBPACK FOOTER //
// ./src/router/subject.js